import frappe from '../frappe';

// Sube un archivo .grb a Frappe y lo asocia a una Sales Order
export const subirArchivoAOrden = (file, ref) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('doctype', 'Sales Order');
    formData.append('docname', ref);
    formData.append('is_private', 0);

    frappe
      .post('/api/method/upload_file', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(({ data }) => resolve(data.message))
      .catch(error => {
        console.error('Error al subir el archivo:', error.response?.data || error.message);
        reject(error);
      });
  });
};
